const routes = [
  {
    path: '/badge-builder',
    name: 'BadgeBuilder/Index',
    meta: {
      requiresAuth: true,
      title: 'Badge Builder'
    },
    component: () => import('./index.vue')
  },
  {
    path: '/badge-builder/builder/:id?',
    name: 'BadgeBuilder/Builder',
    meta: {
      requiresAuth: true,
      title: 'Editor de Badge'
    },
    component: () => import('./builder.vue')
  },
  {
    path: '/badge-builder/print-queue',
    name: 'BadgeBuilder/PrintQueue',
    meta: {
      requiresAuth: true,
      title: 'Fila de Impressao'
    },
    component: () => import('./print-queue.vue')
  },
  {
    path: '/badge-builder/settings',
    name: 'BadgeBuilder/Settings',
    meta: {
      requiresAuth: true,
      title: 'Configuracoes'
    },
    component: () => import('./settings.vue')
  }
]

export { routes }
export default routes
